import React from "react";
import Slider from "react-slick";
import {HeaderMobile} from "components/common/HeaderMobile";
import SignUpForm from "./Form";
import {images} from "assets/img/sign-up/signUp";
import {app} from "app/app";


export class SignUp extends React.Component {
    renderContent() {
        if (this.props.verificationEmailSent) {
            return (
                <div className="sign-up-success">
                    <figure><img src={images.success} alt="Exito"/></figure>
                    <h1>¡Muchas gracias!</h1>
                    <p>Te enviamos un email a <b>{this.props.formData.email.value}</b>, para activar tu cuenta por favor
                        verificá tu correo.</p>
                </div>
            )
        } else {
            return (
                <div className="sign-up-container">
                    <h1>Registro</h1>
                    <p>¿Ya tenés cuenta con {app.productName()}? <a href="/">Clic aquí</a></p>
                    <SignUpForm {...this.props}/>
                </div>
            )
        }
    }

    render() {
        const sliderSettings = {
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
        };

        return (
            <div className={"sign-up" + (this.props.isMobile ? " sign-up-mobile" : "")}>
                <div className="sign-up-side">
                    <img className="logo" src={images.logo} alt={app.productName()}/>
                    <Slider {...sliderSettings}>
                        <div className="slide-item">
                            <figure><img src={images.join} alt=""/></figure>
                            <h3>Sumate a {app.productName()}</h3>
                            <p>En 3 simples pasos ya vas a poder acceder al mundo de las criptomonedas</p>
                        </div>
                        <div className="slide-item">
                            <figure><img src={images.unbeatable} alt=""/></figure>
                            <h3>Refugiate en criptomonedas</h3>
                            <p>“La mejor forma de resguardar tus ahorros. <br/> Comprá y vendé DAI fácil, rápido y al
                                mejor precio
                            </p>
                        </div>
                    </Slider>
                    <footer className="d-flex flex-column align-items-center d-md-none mt-5">
                        <button className="primary-button mb-2" onClick={this.props.renderMobileForm}>CREAR MI CUENTA
                        </button>
                        <button className="secondary-button" onClick={this.props.goToLogin}>INGRESAR</button>
                    </footer>
                </div>
                <div className="sign-up-content">
                    <HeaderMobile/>
                    {this.renderContent()}
                </div>
            </div>
        );
    }
}